import createLucideIcon from '../createLucideIcon';

const LogIn = createLucideIcon('LogIn', [
  ['path', { d: 'M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4', key: 'u53s6r' }],
  ['polyline', { points: '10 17 15 12 10 7', key: '1ail0h' }],
  ['line', { x1: '15', x2: '3', y1: '12', y2: '12', key: 'v6grx8' }],
]);

export default LogIn;
